import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from 'react';
import Header from '../components/Header/Header';
import RotateScreen from '../components/RotateScreen/RotateScreen';
import { BlockScreenWrapperContext } from '../providers/AppBlockScreenProvider';
import NotificationBox from '../components/NotificationBox/NotificationBox';
import NotificationModal from '../components/Modals/NotificationModal/NotificationModal';
import { setChatModal, setNotificationModal } from '../store/reducers/ModalsState/slice';
import ChatModal, { CHAT_MODAL_VIEWS } from '../components/Modals/ChatModal/ChatModal';
import { useAppDispatch, useAppSelector } from '../store/reducers';
import useResponsive from '../hooks/useResponsive';
import styles from './DefaultLayout.module.scss';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
const DefaultLayout = ({ children }) => {
    const dispatch = useAppDispatch();
    const isResponsive = useResponsive('xl');
    const pathname = useLocation();
    const { notificationModal, chatModal } = useAppSelector((state) => state.modal);
    const [showBgColor, setShowBgColor] = useState(false);
    const blockScreen = useContext(BlockScreenWrapperContext);
    useEffect(() => {
        if (pathname.pathname === '/') {
            setShowBgColor(true);
        }
        else {
            setShowBgColor(false);
        }
    }, [pathname]);
    return (_jsxs("div", Object.assign({ className: classNames(styles.element, showBgColor && styles.bgColor) }, { children: [_jsx(Header, {}), blockScreen ? (_jsx(RotateScreen, {})) : (_jsxs(React.Fragment, { children: [children, notificationModal && !isResponsive && (_jsx(NotificationModal, { closeModal: () => dispatch(setNotificationModal(false)) })), chatModal && !isResponsive && (_jsx(ChatModal, { guildChat: false, singleChat: false, chatViews: CHAT_MODAL_VIEWS.LIST_VIEW, closeModal: () => dispatch(setChatModal(false)) })), _jsx(NotificationBox, {})] }))] })));
};
export default DefaultLayout;
